import {useDispatch} from 'react-redux';
import { IonIcon, IonLabel, IonItem, IonInput, IonText } from '@ionic/react';
import { helpCircle } from 'ionicons/icons';

import useHelpAlert from 'hooks/useHelpAlert';
import { stopPropagation } from 'helpers/events';
import { updateLoad } from 'actions/ProjectDataActions';

export default function SafetyFactor({load, safetyFactor, readonly, help}) {
  const dispatch = useDispatch();
  const showHelp = useHelpAlert({title: "Safety Factor", ...(_.isPlainObject(help) ? help : {content: help})});
  const changeSafetyFactor = (event) => {
    const newValue = parseFloat(event.target.value, 10);
    dispatch(updateLoad(load.id, {safetyFactor: newValue}));
  };

  return (
    <IonItem>
      <IonText aria-hidden onClick={showHelp}>
        Safety Factor <IonIcon icon={helpCircle}/>
      </IonText>
      <IonLabel aria-label="Safety Factor"/>
      <IonInput type="number"
        min="1"
        step="0.5"
        style={{textAlign: "right"}}
        value={safetyFactor}
        onIonInput={changeSafetyFactor}
        onIonChange={stopPropagation(changeSafetyFactor)}
        readonly={readonly}
        data-testid="safety-factor"/>
    </IonItem>
  );
}
